export const WRITE_TITLE = (total: number) => `${total} config files added to workspace`;

export const SUMMARY = `bit writes configuration files in different nested locations in your workspace to meet the configuration needs of different components.
IDE is now in-sync with component configuration`;
